export const checkIfNodeHaveText = (blocks: any) => {
  const MEDIA_TYPES = new Set([
    "image",
    "file",
    "attachment",
    "video",
    "canva",
    "youtube",
    "vimeo",
    "embed",
    "media",
    "file-upload",
    "media-embed",
  ]);

  const walk = (nodes: any[]): boolean => {
    if (!Array.isArray(nodes)) return false;

    for (const node of nodes) {
      if (!node || typeof node !== "object") continue;

      if (MEDIA_TYPES.has(node.type) && node.url) {
        return true;
      }

      if ("url" in node && node.url !== "") {
        return true;
      }

      if (typeof node.text === "string" && node.text !== "") {
        return true;
      }

      if (typeof node.character === "string" && node.character !== "") {
        return true;
      }

      if (node.children && walk(node.children)) {
        return true;
      }
    }

    return false;
  };

  return walk(blocks);
};
